'use client'

import { captureError } from '../../instrumentation-client'
import { useEffect } from 'react'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
    captureError(error)
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#0a0a0f',
          color: '#e4e4e7',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: 480, padding: 24 }}>
          <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>Something went wrong</h1>
          <p style={{ fontSize: 14, color: '#a1a1aa', marginBottom: 24 }}>
            An unexpected error occurred. Please try again.
          </p>
          <button
            onClick={() => reset()}
            style={{
              padding: '10px 24px',
              fontSize: 14,
              fontWeight: 500,
              color: '#fff',
              backgroundColor: '#27272a',
              border: '1px solid #3f3f46',
              borderRadius: 8,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
          <p style={{ fontSize: 13, color: '#71717a', marginTop: 32 }}>Follow for updates or reach out on socials</p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', marginTop: 12 }}>
            <a
              href="https://x.com/hypurrfi"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 14, color: '#a1a1aa', textDecoration: 'none' }}
            >
              X
            </a>
            <a
              href="https://t.me/+YvsBvSxlQrVhNDkx"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 14, color: '#a1a1aa', textDecoration: 'none' }}
            >
              Telegram
            </a>
            <a
              href="https://discord.com/invite/CvJPEJjBNn"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 14, color: '#a1a1aa', textDecoration: 'none' }}
            >
              Discord
            </a>
          </div>
        </div>
      </body>
    </html>
  )
}
